import { lazy } from 'react'
import { LANG } from "../language/lang";

import DashboardIcon from '@mui/icons-material/Dashboard';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';

const PublicLayout = lazy(() => import('../layouts/PublicLayout'))
const AuthLayout = lazy(() => import('../layouts/AuthLayout'))
const ProfileLayout = lazy(() => import('../layouts/ProfileLayout'))
const ProtectedRoute = lazy(() => import('../routers/ProtectedRoute'))

const Home = lazy(() => import('../pages/Home'))
const About = lazy(() => import('../pages/About'))
const Pricing = lazy(() => import('../pages/Pricing'))
const Api = lazy(() => import('../pages/Api'))
const Faq = lazy(() => import('../pages/Faq'))
const Contacts = lazy(() => import('../pages/Contacts'))
const Pages = lazy(() => import('../pages/Pages'))
const Login = lazy(() => import('../pages/Auth/Login'))
const Registration = lazy(() => import('../pages/Auth/Registration'))
const Integrations = lazy(() => import('../pages/Profile/Integrations'))

const Dashboard = lazy(() => import('../pages/Profile/Dashboard'))
const Links = lazy(() => import('../pages/Profile/Links'))
const AddLink = lazy(() => import('../pages/Profile/Links/add'))

const ROUTE = [
    {
        path: '/',
        component: <PublicLayout />,
        componentName: 'PublicLayout',
        children: [
            {
                index: true,
                component: <Home />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_HOME")
            },
            {
                path: 'about',
                component: <About />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_ABOUT"),
            },
            {
                path: 'pricing',
                component: <Pricing />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_PRICING"),
            },
            {
                path: 'api-integration',
                component: <Api />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_API"),
            },
            {
                path: 'faq',
                component: <Faq />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_FAQ"),
            },
            {
                path: 'contacts',
                component: <Contacts />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_CONTACTS"),
            },
            {
                path: 'rules',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: false,
                title: LANG("MENU_RULES"),
            },

             {
                path: 'privacy-policy',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: false,
                title: LANG("MENU_PRIVACY_POLICY"),
            },

            {
                path: 'return-policy',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: false,
                title: LANG("MENU_RETURN_POLICY"),
            },

            {
                path: 'cookie-policy',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: false,
                title: LANG("MENU_COOKIE_POLICY"),
            },


        ],
    },
    {
        path: '/auth',
        componentName: 'AuthLayout',
        component: <AuthLayout />,
        children: [
            {
                path: 'login',
                component: <Login />,
            },
            {
                path: 'registration',
                component: <Registration />,
            },
        ],
    },
    {
        path: '/profile',
        componentName: 'ProtectedRoute',
        component: <ProtectedRoute />,
          children: [
            {
                component: <ProfileLayout />,
                path: '/profile',
                componentName: 'ProfileLayout',
                children: [
                  
                    {
                        index: true,
                        path: '',
                        component: <Dashboard />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        title: LANG("MENU_PANEL_HOME"),
                        icon: <DashboardIcon />,
                        store: null
                    },
                  
                    {
                        path: 'links',
                        component: <Links />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        title: LANG("MENU_PANEL_LINKS"),
                        icon: <InsertLinkIcon />,
                        pageHeader: {
                            title: LANG("PAGE_HEADER_LINKS"),
                            button: {
                                text: LANG("BTN_CREATE_NEW_LINK"),
                                variant: 'contained',
                                to: '/profile/links/add',
                            }
                        },
                        store: 'links'
                    },

                    {
                        path: 'links/add',
                        component: <AddLink />,
                        menu: false,
                        onlyMobile: false,
                        secondary: false,
                        title: LANG("MENU_PANEL_LINKS"),
                        pageHeader: {
                            title: LANG("PAGE_HEADER_LINKS_ADD"),
                        },
                        store: 'links'
                    },

                    {
                        path: 'integrations',
                        component: <Integrations />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        title: LANG("MENU_PANEL_INTEGRATIONS"),
                        icon: <IntegrationInstructionsIcon />,
                        pageHeader: {
                            title: LANG("PAGE_HEADER_INTEGRATIONS"),
                        },
                        store: 'user'
                    },
                   

                ],
            },
        ],
    }


]

export default ROUTE